import React from "react";
import {useContainerMediaQueriesChecks} from "../../hooks/use-container-media-queries-checks.hook";
import {computePaymentMethodIconSize} from "./compute-payment-method-icon-size";
import {observer} from "mobx-react";
import {
    ICardNetworkIconOptions
} from "../../services/booking/models/payment/methods/card/networks/card-network.view-model.interface";


export const LogoDiscoverIcon: React.FC<ICardNetworkIconOptions> = observer((props) => {

    props = {
        ...props,
        preferredOriginalSize: {
            ...props.preferredOriginalSize,
            width: 92,
            height: 92
        }
    }

    return (
        <svg
            {...computePaymentMethodIconSize(useContainerMediaQueriesChecks(), props)}
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 256 256"
            fillRule="nonzero"
        >
            <g
                fill="none"
                fillRule="nonzero"
                stroke="none"
                strokeWidth="1"
                strokeLinecap="butt"
                strokeLinejoin="miter"
                strokeMiterlimit="10"
                strokeDasharray=""
                strokeDashoffset="0"
                fontFamily="none"
                fontWeight="none"
                fontSize="none"
                textAnchor="none"
                style={{ mixBlendMode: 'normal' }}
            >
                <g transform="scale(5.33333,5.33333)">
                    {/* Stratul "border" */}
                    <path
                        d="M45,35c0,2.2 -1.8,4 -4,4h-34c-2.2,0 -4,-1.8 -4,-4v-22c0,-2.2 1.8,-4 4,-4h34c2.2,0 4,1.8 4,4z"
                        fill="#ffffff"
                        stroke="#000000"
                        strokeWidth="0.2"
                    />

                    {/* Al doilea strat colorat */}
                    <path
                        d="M45,35c0,2.2 -1.8,4 -4,4h-25c0,0 23.6,-3.8 29,-15zM22,24c0,1.7 1.3,3 3,3c1.7,0 3,-1.3 3,-3c0,-1.7 -1.3,-3 -3,-3c-1.7,0 -3,1.3 -3,3z"
                        fill="#ff6d00"
                    />

                    {/* Detaliile negre */}
                    <path
                        d="M11.2,21h1.1v6h-1.1zM17.2,24c0,1.7 1.3,3 3,3c0.5,0 0.9,-0.1 1.4,-0.3v-1.3c-0.4,0.4 -0.8,0.6 -1.4,0.6c-1.1,0 -1.9,-0.8 -1.9,-2c0,-1.1 0.8,-2 1.9,-2c0.5,0 0.9,0.2 1.4,0.6v-1.3c-0.5,-0.2 -0.9,-0.4 -1.4,-0.4c-1.7,0.1 -3,1.5 -3,3.1zM30.6,24.9l-1.6,-3.9h-1.2l2.5,6h0.6l2.5,-6h-1.2zM33.9,27h3.2v-1h-2.1v-1.6h2v-1h-2v-1.4h2.1v-1h-3.2zM41.5,22.8c0,-1.1 -0.7,-1.8 -2,-1.8h-1.7v6h1.1v-2.4h0.1l1.6,2.4h1.4l-1.8,-2.5c0.8,-0.2 1.3,-0.8 1.3,-1.7zM39.2,23.8h-0.3v-1.8h0.3c0.7,0 1.1,0.3 1.1,0.9c0,0.5 -0.3,0.9 -1.1,0.9zM7.7,21h-1.7v6h1.6c2.5,0 3.1,-2.1 3.1,-3c0.1,-1.8 -1.2,-3 -3,-3zM7.4,26h-0.3v-4h0.4c1.5,0 2.1,1 2.1,2c0,0.4 -0.1,2 -2.2,2zM15.3,23.3c-0.7,-0.3 -0.9,-0.4 -0.9,-0.7c0,-0.4 0.4,-0.6 0.8,-0.6c0.3,0 0.6,0.1 0.9,0.5l0.6,-0.8c-0.5,-0.5 -1,-0.7 -1.7,-0.7c-1,0 -1.8,0.7 -1.8,1.7c0,0.8 0.4,1.2 1.4,1.6c0.6,0.2 1.1,0.4 1.1,0.9c0,0.5 -0.4,0.8 -0.9,0.8c-0.5,0 -1,-0.3 -1.2,-0.8l-0.7,0.7c0.5,0.8 1.1,1.1 2,1.1c1.2,0 2,-0.8 2,-1.9c0,-0.9 -0.4,-1.3 -1.6,-1.8z"
                        fill="#000000"
                    />
                </g>
            </g>
        </svg>



    );
});
